import React, {useEffect, useState} from 'react';

const defaultColors = [
    "#000000", "#FFFFFF", "#00B0FF", "#0B64CB", "#F8D541", "#FF9436",
    "#53CDBE", "#8B6DE2", "#F46AD5", "#66BE63", "#F82121"
];

const PaletteCouleursAffichageToutes = ({defaultColor, onColorChange, showTransparent = false}) => {
    const [color, setColor] = useState(defaultColor || (showTransparent ? 'transparent' : '#00B0FF'));

    // ⚠️ Mettre à jour color si defaultColor change
    useEffect(() => {
        setColor(defaultColor || (showTransparent ? 'transparent' : '#00B0FF'));
    }, [defaultColor, showTransparent]);

    const handleColorClick = (col) => {
        setColor(col);
        onColorChange(col);
    };

    return (
        <div style={{
            display: "flex"
            , padding: "4px 0",
            alignItems: "center",
            alignContent: "center",
            flexWrap: "wrap"
        }}>

            {showTransparent && (
                <div
                    key="transparent"
                    style={{
                        border: color === 'transparent' ? '2px solid #989797' : '2px solid transparent',
                        borderRadius: "20px",
                        padding: '3px',
                        cursor: 'pointer'
                    }}
                    onClick={() => handleColorClick('transparent')}
                    title="Transparent"
                >
                    <div
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '20px',
                            backgroundImage: `linear-gradient(45deg, #ccc 25%, transparent 25%), 
                                              linear-gradient(-45deg, #ccc 25%, transparent 25%), 
                                              linear-gradient(45deg, transparent 75%, #ccc 75%), 
                                              linear-gradient(-45deg, transparent 75%, #ccc 75%)`,
                            backgroundSize: '10px 10px',
                            backgroundPosition: '0 0, 0 5px, 5px -5px, -5px 0px',
                            backgroundColor: '#fff'
                        }}
                    />
                </div>
            )}

            {defaultColors.map((col) => (
                <div
                    key={col}
                    style={{
                        border: color === col ? '2px solid #989797' : '2px solid transparent',
                        borderRadius: "20px",
                        padding: '3px',
                        cursor: 'pointer'
                    }}
                    onClick={() => handleColorClick(col)}
                >
                    <div
                        style={{
                            background: col,
                            width: '28px',
                            height: '28px',
                            borderRadius: '20px'
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default PaletteCouleursAffichageToutes;